import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiButtonDirective } from './ui-button.directive';

@NgModule({
  declarations: [UiButtonDirective],
  exports: [UiButtonDirective],
  imports: [CommonModule]
})
export class UiButtonModule {}
